import { render, staticRenderFns } from "./ManterJuizo.vue?vue&type=template&id=674e2240&scoped=true&"
import script from "./ManterJuizo.vue?vue&type=script&lang=js&"
export * from "./ManterJuizo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674e2240",
  null
  
)

export default component.exports